import { useVerifyWelcomeCodeMutation } from "../../redux";

const useVerifyWelcomeToken = () => {
    const [_verify, { isLoading, ...verifyData }] = useVerifyWelcomeCodeMutation();

    const verify = (emailAddress, welcomeCode) => {
        return new Promise((resolve, reject) => {
            return _verify({ emailAddress, welcomeCode })
                .unwrap()
                .then(
                    r => {
                        return resolve(r);
                    },
                    e => {
                        return reject(e);
                    }
                )
        });
    };

    return { verify, isLoading, data: { isLoading, ...verifyData } };
};

export default useVerifyWelcomeToken;